import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/color-palette/pages/CalculatorPage";

export const Route = createFileRoute("/color-palette")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/color-palette",
      title: m.cp_meta_title(),
      description: m.cp_meta_description(),
      toolName: m.cp_tool_name(),
      faqs: [
        { q: m.cp_faq_q1(), a: m.cp_faq_a1() },
        { q: m.cp_faq_q2(), a: m.cp_faq_a2() },
        { q: m.cp_faq_q3(), a: m.cp_faq_a3() },
        { q: m.cp_faq_q4(), a: m.cp_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
